const get_started = {
    page_title: '시작하기',
    title: '성공하는 데 도움이 될 탐색 항목',
    subtitle: 'Logto의 가치를 빠르게 얻을 수 있는 몇 가지 방법',
    develop: {
        title: '개발: 앱을 통합하는 데 5분이면 충분합니다',
        title_cloud: '개발: 몇 분 안에 앱을 안전하게 통합하기',
        subtitle_cloud: '아니면 미리 만들어진 SDK와 자습서로 앱을 5분만에 통합해 보세요.',
        try_mcp: 'MCP로 한 번의 프롬프트로 통합 시도해 보기',
    },
    customize: {
        title: '사용자 정의: 훌륭한 로그인 경험 전달하기',
        preview: {
            title: '방금 사용자 정의한 로그인 경험의 실시간 미리보기 확인하기',
            subtitle: '작동 방식을 확인하려면 지금 Logto 로그인 경험을 시도해보세요',
        },
        connector: {
            title: '더 많은 커넥터 추가하여 더 많은 소셜 로그인 방식 지원하기',
            subtitle: '비밀번호 없는 로그인을 시도하고 고객에게 안전하고 원활한 경험을 제공하세요',
        },
        continue_customizing: '사용자 정의 계속하기',
        try_now: '지금 시도해보세요',
        add_more: '더 추가하기',
    },
    secure: {
        title: '보안: 리소스 보호',
    },
    manage: {
        title: '관리: 제품 및 사용자에 대한 액세스 제어 정의',
        rbac: {
            title: '롤 기반 액세스 제어 추가하여 리소스 보호',
            subtitle: '다양한 사용 사례에 대해 확장 가능한 역할 권한부여를 통해 리소스 제어',
        },
        create_roles: '역할 생성',
    },
    convert_to_production: {
        card_title: '라이브 준비가 되셨나요? 프로덕션 설정을 시작하는 것을 잊지 마세요!',
        title: '프로젝트를 개발 모드에 두지 마세요',
        subtitle: '무료 테스트를 위해 개발 테넌트를 사용하고 있습니다. 라이브로 전환하려면 프로덕션 테넌트를 생성하거나 변환하세요. 맞춤 설정이 필요하신가요? <a>문의하기</a>',
        convert_button: '프로덕션 테넌트로 변환',
    },
    oss_cloud: {
        try: {
            title: '운영 작업은 건너뛰고 Logto Cloud를 무료로 사용해 보세요',
            badge: '추천',
            description: '유지보수가 필요 없는 완전 관리형 Logto와 함께 MCP 기반 빠른 통합, 멀티 테넌트 지원, 팀 협업, 모든 프리미엄 기능을 이용할 수 있습니다. 신용카드 없이 무료로 시작하세요.',
            action: 'Logto Cloud 살펴보기',
        },
        private_cloud: {
            title: '컴플라이언스 또는 맞춤형 배포가 필요하신가요?',
            card_title: '프라이빗 클라우드',
            description: '완전한 데이터 격리, 사용자 지정 도메인, SLA 보장을 갖춘 전용 Logto 인스턴스를 이용하세요. 엄격한 데이터 거주성 또는 컴플라이언스 요구사항이 있는 기업에 적합합니다. 인프라는 저희가 관리하므로 제품에 집중할 수 있습니다.',
        },
        sidebar: {
            title: '호스팅이 아니라 개발에 집중하세요.',
            description: '인증 인프라는 Logto Cloud에 맡기세요.',
            action: 'Logto Cloud 사용해 보기',
        },
    },
    view_all: '모두 보기 →',
};
export default Object.freeze(get_started);
